import {luiUpdateParams} from "../../view/components/lui/utils/lui"
import {action, makeObservable, observable} from "mobx"
import {Config} from "../config/Config"


/**
 *  Singleton: Состояние приложения
 */
export default class AppState {
    /** @returns {AppState} */
    static get instance(){ return AppState.#instance??(new AppState()) }
    static #instance

    #inited = false

    lang = Config.langsAllowed[0]

    /**
     * Singleton: Состояние приложения
     */
    constructor(){
        if(AppState.#instance!==undefined) return AppState.#instance
        AppState.#instance = this

        makeObservable(this, {
            lang: observable,
            _update: action
        })
    }


    /**
     * @param {string} params.lang - язык
     * @private
     */
    _update(params){
        luiUpdateParams(this, params, ['lang'])
    }


    /**
     * @param {string} lang
     */
    setLang(lang){
        lang = lang.toLowerCase()
        if(Config.langsAllowed.includes(lang)) this._update({ lang: lang })
    }


    init(){
        if(this.#inited){
            console.warn('AppState already inited!')
            return this
        }
        // определение языка браузера
        this.setLang( navigator.language.split('-')[0] )
        return this
    }

}

